
// player = https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, BreadCrumb, FreeSpeakingConfigModal } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component({
  components: {
    NavBar,
    BreadCrumb,
    FreeSpeakingConfigModal
  }
})
export default class TaskFreeSpeakingView extends Vue {
  data () {
    return this.getResetData()
  }

  getResetData () {
    return {
      isLoading: false,
      remainTime: '',
      disabled: true,
      completed: false,
      transcription: '',
      isPlaying: false,
      isRecording: false,
      hasRecorded: false,
      filePath: null,
      maxDuration: 120000,
      currentTimeInterval: null,
      currentTimeMillis: 0,
      itWasPlaying: false,
      displayConfig: false,
      taskId: null,
      recordingEnded: false,
      localAudioTrack: null,
      audioStream: null,
      audioSource: null,
      recordBuffer: [],
      uploadChunkCount: null,
      recorderStartTimer: null,
      audioUrl: null,
      audioElement: null
    }
  }

  mounted () {
    this.taskId = this.$route.params.taskId
    this.getTaskData()
  }

  setCurrentTimeTimeout () {
    this.currentTimeInterval = setInterval(this.updateCurrentTime, 1000)
  }

  updateCurrentTime () {
    this.currentTimeMillis += 1000
  }

  updatePlayerTime () {
    this.currentTimeMillis = Math.floor(this.audioElement.currentTime) * 1000
  }

  updatePlayerDuration () {
    this.maxDuration = Math.floor(this.audioElement.duration) * 1000
  }

  formatSecs (val) {
    var d = Math.abs(val) / 60000
    var mins = Math.floor(d)
    var secs = Math.floor((d - mins) * 60)
    var timerMins = mins === 0 ? '' : mins < 10 ? `0${mins}` : mins
    var timerSecs = secs < 10 ? `0${secs}` : secs
    return `${timerMins}${timerMins === '' ? '' : ':'}${timerSecs}`
  }

  record () {
    this.isRecording = true
    this.hasRecorded = true
    this.setCurrentTimeTimeout()
    this.startRecordAudio()
  }

  pause () {
    if (this.audioElement) {
      this.isPlaying = false
      this.audioElement.pause()
    } else {
      this.isRecording = false
      clearInterval(this.currentTimeInterval)
      this.stopRecordAudio()
    }
  }

  play () {
    this.isPlaying = true
    this.audioElement.play()
  }

  playEnded () {
    this.pause()
  }

  closeConfigModal () {
    this.displayConfig = false
    if (this.itWasPlaying) {
      this.record()
      this.itWasPlaying = false
    }
  }

  openConfigModal () {
    if (this.isRecording) {
      this.itWasPlaying = true
      this.pause()
    }
    this.displayConfig = true
  }

  /* async save () {
    this.recordingEnded = true
  } */

  async save () {
    await this.updateOnServer(false)
  }

  async finish () {
    await this.updateOnServer(true)
  }

  displayModalFinish () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you won`t be able to change it back.',
      onConfirm: () => {
        this.finish()
      },
      canCancel: true
    })
  }

  requestDeleteAudioFiles () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you will not be able to recover the recorded audio.',
      onConfirm: () => {
        this.deleteAudioFiles()
      },
      canCancel: true
    })
  }

  async startRecordAudio () {
    this.recordingEnded = false
    this.audioStream = new MediaStream([this.localAudioTrack])
    const options = { mimeType: 'audio/webm' }
    this.mediaRecorder = new MediaRecorder(this.audioStream, options)
    this.mediaRecorder.ondataavailable = this.handleDataAvailable
    this.mediaRecorder.onstop = this.handleRecorderStop
    this.recorderStartTimer = Number(`${this.currentTimeMillis}`)
    this.uploadChunkCount = 1
    this.mediaRecorder.start(1000)
  }

  stopRecordAudio () {
    this.recordingEnded = true
    this.mediaRecorder.stop()
    // clearInterval(this.playerInterval)
    // this.playerInterval = null
    // this.uploadToServer(this.recordedChunks.splice(0, this.recordedChunks.length), this.uploadChunkCount)
  }
  // updateRecordAudioTrack()

  handleDataAvailable (event) {
    if (event.data.size > 0) {
      if (this.recordBuffer.length === 0) {
        this.recordBuffer = [event.data]
      } else {
        this.uploadToServer(this.recordBuffer, this.uploadChunkCount)
        this.recordBuffer = [event.data]
        this.uploadChunkCount++
        if (this.uploadChunkCount === 120) {
          this.pause()
        }
      }
    } else {
      // …
    }
  }

  updateAudioInput (track) {
    this.localAudioTrack = track
  }

  /* async getChunkCount () {
    this.isLoading = true
    try {
      var response = await fetch(encodeURI(`${process.env.VUE_APP_SERVERURL}/getLastChunkIdx/${this.taskId}`), {
        headers: { Authorization: `Bearer ${this.$store.state.access_token}` }
      })
      var resp = await response.json()
      if (resp.error) {
        console.error(resp.error)
        throw resp.error
      }
      this.currentTimeMillis = resp.diff
      // this.timerInterval = setInterval(this.updateTimer, 1000)
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      console.error(e)
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: e,
        canCancel: false
      })
    }
  } */

  fillRemainTime (due) {
    if (due) {
      var now = new Date()
      var days = (due.valueOf() - now.valueOf()) / (1000 * 3600 * 24)
      if (days <= 0) {
        this.remainTime = 'Expired'
      } else {
        var hours = (days - Math.floor(days)) * 24
        var mins = 0
        if ((hours - Math.floor(hours)) > 0) {
          mins = (hours - Math.floor(hours)) * 60
        }
        var daysString = days < 10 ? days < 1 ? '' : `0${Math.floor(days)} Days and ` : `${Math.floor(days)} Days and `
        var hoursString = hours < 10 ? `0${Math.floor(hours)}` : Math.floor(hours)
        var minsString = mins < 10 ? `0${Math.floor(mins)}` : Math.floor(mins)

        this.remainTime = `${daysString}${hoursString}:${minsString} h `
      }
    } else {
      this.remainTime = ''
    }
  }

  async getTaskData () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getFreeSpeakingTaskData${this.taskId ? '/' + this.taskId : ''}`))
      this.taskData = JSON.parse(resp.data)
      this.disabled = resp.completed || new Date(resp.due) <= new Date()
      this.completed = resp.completed
      this.transcription = resp.content
      this.fillRemainTime(new Date(resp.due))
      if (!this.taskId) {
        this.taskId = resp.id
      }
      this.filePath = resp.filePath
      if (this.audioElement) {
        this.audioElement.removeEventListener('ended', this.pause)
        this.audioElement.removeEventListener('timeupdate', this.updatePlayerTime)
        this.audioElement.removeEventListener('durationchange', this.updatePlayerDuration)
      }
      if (this.filePath) {
        this.displayConfig = false
        this.audioUrl = encodeURI(`${process.env.VUE_APP_SERVERURL}/media/${this.filePath}?cb=${new Date().getTime()}`)
        const blob = await FetchWrapper.getBlob(this.audioUrl)
        const blobUrl = URL.createObjectURL(blob)
        this.audioElement = new Audio(blobUrl)
        this.audioElement.addEventListener('ended', this.pause)
        this.audioElement.addEventListener('timeupdate', this.updatePlayerTime)
        this.audioElement.addEventListener('durationchange', this.updatePlayerDuration)
        this.audioElement.load()
      } else {
        this.displayConfig = true
        this.audioUrl = null
        this.audioElement = null
        this.maxDuration = 120000
      }
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }

  async uploadToServer (data, chunkIdx) {
    const blob = new Blob(data, { type: 'audio/webm; codecs=opus' })
    // filename = '2-5612112-1.webm'
    const formData = new window.FormData()
    formData.append(
      'file', blob
    )
    formData.append(
      'chunkIdx', chunkIdx
    )
    formData.append(
      'recorderStartTimer', this.recorderStartTimer
    )
    formData.append(
      'recordingEnded', this.recordingEnded
    )
    formData.append(
      'taskId', this.taskId
    )
    try {
      const resp = await FetchWrapper.postForm(`${process.env.VUE_APP_SERVERURL}/audioUploadAudioChunk`, formData)
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not upload audio chunk. Reason: ${e}`,
        canCancel: false
      })
      this.pause()
    }
  }

  async updateOnServer (completed) {
    this.isLoading = true

    var data = { }

    const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/updateFreeSpeakingTaskData`,
      { data: JSON.stringify(data), id: Number(this.taskId), completed }
    )

    this.isLoading = false
    if (resp.error || resp.statusCode) {
      this.$buefy.dialog.confirm({
        title: 'Error while saving.',
        message: resp.error,
        canCancel: false
      })
    } else {
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Task saved Successfully',
        onConfirm: () => {
          /* if (completed) {
            window.location.href = '/home/tasks'
          } else { */
          window.location.href = `/home/freeSpeaking/${this.taskId}`
          // }
        },
        canCancel: false
      })
    }
  }

  async deleteAudioFiles () {
    this.isLoading = true
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/deleteFreeSpeakingTaskFiles/${this.taskId}`))
      this.isLoading = false
      this.currentTimeMillis = 0
      await this.getTaskData()
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not delete audio files.',
        canCancel: false
      })
    }
  }
}
